// extracted by mini-css-extract-plugin
export default {"checkbox":"OptionGroup_checkbox__k36w6","selected":"OptionGroup_selected__tBbFO"};